<template>
    <div>
        <div class="flex items-center justify-between"
             v-for="(option, index) in options"
        >
            <label class="block text-sm font-medium leading-5 text-gray-700 w-1/3"
                   v-html="option.name"
            ></label>

            <form-quantity v-model="value[index].value"
                           class="w-1/3"
                           :max="groupMax - groupTotal + value[index].value"
            ></form-quantity>

            <div class="w-1/3 text-right">
                £{{ (value[index].value * option.price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
            </div>
        </div>
    </div>
</template>

<script>
    import FormQuantity from "../../form/Quantity";

	export default {
	    props: {
	        options: {
	            type: Array,
                required: true,
            },

            groupMax: {
	            type: Number,
            },

	        value: {
	            type: Array,
                required: true,
            },
        },

        components: { FormQuantity },

        computed: {
	        groupTotal() {
	            return _.sumBy(this.value, 'value');
            }
        }
	}
</script>
